module.exports = __webpack_public_path__ + "img/randomizer-details1.891c2a68.png";